import { type FunctionComponent } from 'preact'
import { html } from 'htm/preact'
import type { AppState } from '../../state.js'

export const ToolPlaceholder:FunctionComponent<{
    state:AppState
}> = function ToolPlaceholder () {
    return html`<div class="route tool-placeholder">
        <p><a href="/tools">← Back to Tools</a></p>
        <h2>Coming soon</h2>
        <p>This tool is under construction.</p>
    </div>`
}
